export default {"src":"https://fishbrain.com/_next/static/media/nevada.e73f8cfb.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};